import { ListRange, SearchCriteriaBase } from '../../common/models';
import { ApprovalStatusEnum, ListQueryParam } from '../../common/constants';
import { PlannerProfileType } from '../constants/planner-profile.constant';
import { LocalDate } from './local-date.model';

export class PlannerProfile {
  id: number;
  name: string;
  description: string;
  createdAt: LocalDate;
  createdBy: number;
  createdByEmail: string;
  isDefault: boolean;
  type: PlannerProfileType;
  subscription?: boolean;
  constructor(params?: PlannerProfile) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class PlannerProfileListSearchCriteria extends SearchCriteriaBase {
  [ListQueryParam.Filter]: string;
  [ListQueryParam.Approved]: boolean;
  [ListQueryParam.ApprovalStatus]?: ApprovalStatusEnum;

  constructor(params?: Partial<PlannerProfileListSearchCriteria> | ListRange) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class PlannerProfileBriefListSearchCriteria extends PlannerProfileListSearchCriteria {
  [ListQueryParam.Type]: string;

  constructor(params?: Partial<PlannerProfileBriefListSearchCriteria> | ListRange) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}
